@if (menu) {
<div class="link-nav">
  @for (menuItem of menu; track menuItem) {
  <div [ngClass]="menuItem.children ? 'header-menu-dropdown' : ''" class="-link-items">
    @if (!menuItem.children && !menuItem.external && !menuItem.hidedesktop) {
    <a
      [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
      [routerLink]="'/' + menuItem.path"
      aria-label="MainNav">
      {{ menuItem.title }}
    </a>
    } @if (!menuItem.children && menuItem.external) {
      <a
        [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
        href="{{ menuItem.path }}"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="MainNav">
        {{ menuItem.title }}
      </a>
      @if (menuItem.children) {
        <app-link>{{ menuItem.title }}<icon icon="dropdown" class="-custom-size-icon"></icon></app-link>
      }
      @if (menuItem.children) {
        <header-menu-dropdown
          class="-menu"
          [menuContent]="menuItem" 
          [type]="menuItem.type ? menuItem.type : 'tabs'">
        </header-menu-dropdown>
      }
    }
  </div>
  }
</div>
}
